
import {
  AbilityLimitation,
  CharacterFeature,
  Modifier,
  RollPlusUpgradable,
  SpellLimitation,
  WeaponLimitation
} from "@dndModels";
import { Feature } from "@models";
import { AbilityScoreType } from "@dndModels/Types";

export class Bonus {
  rolls: RollPlusUpgradable = new RollPlusUpgradable();
  types: string[] = [];
  subtypes: string[] = [];
  source = "";
  excluded: string[] = [];
  required: string[] = [];
  excluded2: string[] = [];
  required2: string[] = [];
  weapon_id = "";
  replace_asm: AbilityScoreType | "None" = "None";
  class_id = "";
  weapon_keywords: string[] = [];
  excluded_weapon_keywords: string[] = [];
  damage_types: string[] = [];
  magic_schools: string[] = [];
  spell_list_ids: string[] = [];
  levels: number[] = [];
  magical_weapons_only = false;

  char_feature: CharacterFeature | Feature = new CharacterFeature();

  get apply_to() {
    if (this.char_feature.floating_feature instanceof Modifier) {
      return this.char_feature.floating_feature.apply_to;
    }
    return [];
  }

  get weapon_limit() {
    if (this.char_feature.floating_feature instanceof Modifier) {
      return this.char_feature.floating_feature.weapon_limit;
    }
    return new WeaponLimitation();
  }

  get spell_limit() {
    if (this.char_feature.floating_feature instanceof Modifier) {
      return this.char_feature.floating_feature.spell_limit;
    }
    return new SpellLimitation();
  }

  get ability_limit() {
    if (this.char_feature.floating_feature instanceof Modifier) {
      return this.char_feature.floating_feature.ability_limit;
    }
    return new AbilityLimitation();
  }

  // constructor(obj?: any) {
  //   if (obj) {
  //     this.rolls = obj.rolls ? new RollPlus(obj.rolls) : new RollPlus();
  //     this.types = obj.types ? obj.types : [];
  //     this.subtypes = obj.subtypes ? obj.subtypes : [];
  //     this.source = obj.source ? obj.source : "";
  //     this.excluded = obj.excluded ? obj.excluded : [];
  //     this.required = obj.required ? obj.required : [];
  //     this.excluded2 = obj.excluded2 ? obj.excluded2 : [];
  //     this.required2 = obj.required2 ? obj.required2 : [];
  //     this.weapon_id = obj.weapon_id ? obj.weapon_id : "";
  //     this.replace_asm = obj.replace_asm ? obj.replace_asm : "";
  //     this.class_id = obj.class_id ? obj.class_id : "";

  //   }
  // }

  clone() {
    const new_obj = new Bonus();
    new_obj.copy(this);
    return new_obj;
  }

  copy(copyMe: Bonus) {
    this.rolls = copyMe.rolls.clone();
    this.types = [...copyMe.types];
    this.subtypes = [...copyMe.subtypes];
    this.source = copyMe.source;
    this.excluded = [...copyMe.excluded];
    this.required = [...copyMe.required];
    this.excluded2 = [...copyMe.excluded2];
    this.required2 = [...copyMe.required2];
    this.weapon_id = copyMe.weapon_id;
    this.replace_asm = copyMe.replace_asm;
    this.class_id = copyMe.class_id;
    this.weapon_keywords = [...copyMe.weapon_keywords];
    this.excluded_weapon_keywords = [...copyMe.excluded_weapon_keywords];
    this.damage_types = [...copyMe.damage_types];
    this.magic_schools = [...copyMe.magic_schools];
    this.spell_list_ids = [...copyMe.spell_list_ids];
    this.levels = [...copyMe.levels];
    this.magical_weapons_only = copyMe.magical_weapons_only;

    this.char_feature = copyMe.char_feature;
  }
}